import React, { useRef, useState } from 'react';
import { InputProps } from '../../models/type';
import { useFormContext } from 'react-hook-form';
import clientUtils from '../../Utils/clientUtils';
import { Button, CircularProgress, InputAdornment, TextField } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const CustomFileInput = ({  name, label, typeValue, file, ...props }: InputProps) => {
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext();
  // console.log('props', props);
  const error = errors[name]?.message as string | undefined;
  const id = `${name}-${props.type}-${label}`;
  const inputFileRef = useRef(null);
  const inputAction = props.inputAction;
  const isUploadingInProgress = props.uploadingInProgress;
  const [inputImgPreviewUrl, setInputImgPreviewUrl] = useState(null);



  const inputImagePreviewSet = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setInputImgPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setInputImgPreviewUrl(null);
    }
  };

  const handleClickInputFile = (event, inputAction) => {
    if (inputAction === 'Upload') {
      inputFileRef.current.click();
    } else if (inputAction === 'Download' && props.onInputAction) {
      props.onInputAction(inputAction, null, name);
    }
  };
  const onKeyPress = (event) => {
    if (typeValue === 'number') {
      return clientUtils.keypress(event);
    }
  };
  const getInputLableProps = (value: string) => {
    // console.log(value)
    if (value) {
      return { shrink: true };
    }
    return {};
  };
  const handleChangeInputFile = (event) => {
    event.preventDefault();
    inputImagePreviewSet(event);

    let file = event.target.files[0];
    if (file) {
      setValue(name, file.name);
      // setValue('file', file);
      // setValue('fileUrl', null);
      if (props.onInputAction) {
        props.onInputAction(inputAction, file, name);
      }
    }
  };
  return (
    <>
      {props.imagePreviewEnabled ? (
        <>
          <div style={{ backgroundColor: '#fff', border: '1px solid #D3D3D3', borderRadius: '10px', padding: '15px' }}>
            <TextField
              id={id}
              label={label}
              type={typeValue}
              defaultValue={props.value}
              helperText={error ? error : props.description}
              variant="outlined"
              placeholder={props.placeholder}
              size="small"
              fullWidth
              error={Boolean(errors[name])}
              onKeyPress={onKeyPress}
              disabled={true}
              {...register(name)}
              InputLabelProps={getInputLableProps(props.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ marginTop: 0 }}>
                    <AttachFileIcon fontSize="small" />
                  </InputAdornment>
                ),
                style: {
                  marginBottom: props.description || error ? '0px' : '10px',
                  cursor: 'pointer',
                },
                endAdornment: (
                  <InputAdornment position="end" sx={{ marginTop: '2px', fontSize: '21px', marginRight: '8px' }}>
                    {inputAction === 'Upload' && !isUploadingInProgress && (
                      <FileUploadIcon color="success" titleAccess="Upload" />
                    )}
                    {inputAction === 'Upload' && isUploadingInProgress && <CircularProgress size={25} color="success" />}
                    {inputAction === 'Download' && props.value !== '' && (
                      <FileDownloadIcon titleAccess="Download" color="success" />
                    )}
                  </InputAdornment>
                ),
              }}
              onClick={(e) => handleClickInputFile(e, inputAction)}
            />
            {inputAction === 'Upload' && (
              <input type="file" ref={inputFileRef} onChange={handleChangeInputFile} style={{ display: 'none' }} />
            )}
            {inputAction === 'Download' && <input id="outcome" style={{ display: 'none' }} />}

            {/* Image Preview */}
            <div style={{ height: 'auto', width: 'auto', borderRadius: '10px', padding: '14px 10px' }}>
              {inputImgPreviewUrl !== null && (
                <img style={{ borderRadius: '10px' }} src={`${inputImgPreviewUrl}`} height={'100%'} width={'100%'} />
              )}
              {props.imageUrl ? (
                <img style={{ borderRadius: '10px' }} src={`${props.imageUrl}`} height={'100%'} width={'100%'} />
              ) : (
                <>{inputImgPreviewUrl == null && <p style={{ textAlign: 'center', margin: '0px' }}>No Preview Available </p>}</>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <TextField
            id={id}
            label={label}
            type={typeValue}
            defaultValue={props.value}
            helperText={error ? error : props.description}
            variant="outlined"
            placeholder={props.placeholder}
            size="small"
            fullWidth
            error={Boolean(errors[name])}
            onKeyPress={onKeyPress}
            disabled={true}
            {...register(name)}
            InputLabelProps={getInputLableProps(props.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ marginTop: 0 }}>
                  <AttachFileIcon fontSize="small" />
                </InputAdornment>
              ),
              style: {
                marginBottom: props.description || error ? '0px' : '10px',
                cursor: 'pointer',
              },
              endAdornment: (
                <InputAdornment position="end" sx={{ marginTop: '2px', fontSize: '21px', marginRight: '8px' }}>
                  {inputAction === 'Upload' && !isUploadingInProgress && <FileUploadIcon color="success" titleAccess="Upload" />}
                  {inputAction === 'Upload' && isUploadingInProgress && <CircularProgress size={25} color="success" />}
                  {inputAction === 'Download' && props.value !== '' && (
                    <FileDownloadIcon titleAccess="Download" color="success" />
                  )}
                </InputAdornment>
              ),
            }}
            onClick={(e) => handleClickInputFile(e, inputAction)}
          />
          {inputAction === 'Upload' && (
            <input type="file" ref={inputFileRef} onChange={handleChangeInputFile} style={{ display: 'none' }} />
          )}
          {inputAction === 'Download' && <input id="outcome" style={{ display: 'none' }} />}
        </>
      )}
    </>
  );
};

export default CustomFileInput;
